import type { SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

/**
 * Hyperion's Switchboard mark.
 *
 * The connected cells represent the product's tools and integrations while
 * the highlighted centre cell represents the active access/configure lens.
 * It intentionally uses `currentColor` so destination chrome controls its
 * colour in every theme and state.
 */
export function SwitchboardIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.65}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path
        d="M7.5 6.5h2M14.5 6.5h2M7.5 17.5h2M14.5 17.5h2M6.5 7.5v2M17.5 7.5v2M6.5 14.5v2M17.5 14.5v2"
        opacity=".45"
      />
      <rect x="3.25" y="3.25" width="5" height="5" rx="1.35" />
      <rect x="15.75" y="3.25" width="5" height="5" rx="1.35" />
      <rect x="3.25" y="15.75" width="5" height="5" rx="1.35" />
      <rect x="15.75" y="15.75" width="5" height="5" rx="1.35" />
      <rect x="9.5" y="9.5" width="5" height="5" rx="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r=".85" fill="white" stroke="none" />
    </svg>
  );
}

export function AccessLensIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <circle cx="10.5" cy="10.5" r="5.75" />
      <path d="m15 15 4.25 4.25M8.25 10.5h4.5M10.5 8.25v4.5" />
    </svg>
  );
}

export function ConfigureLensIcon({ className, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <path d="M4 7h9M17 7h3M4 17h3M11 17h9" />
      <circle cx="15" cy="7" r="2" />
      <circle cx="9" cy="17" r="2" />
    </svg>
  );
}
